export const LmUserClaim = 'SD.Location.isSdLocation';
export const AppAccessKey = 'appAccess';
export const SdIdmCore = 'SD.IDM.CORE';
export const RETURN_URL = 'ReturnUrl';
